module.exports = __webpack_public_path__ + "public/img/bar-5.dfb52f26.png";